var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"legal"}},[_c('div',{staticClass:"inner",domProps:{"innerHTML":_vm._s(_vm.touDetail)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }